<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.96809 6.38233C3.73647 7.922 3 9.87499 3 12C3 14.125 3.73648 16.078 4.96811 17.6177L7.82841 14.7574C7.30488 13.967 7 13.0191 7 12C7 10.9809 7.30487 10.0331 7.82839 9.24262L4.96809 6.38233ZM6.3823 4.96811L9.2426 7.82841C10.033 7.30488 10.9809 7 12 7C13.0184 7 13.9657 7.30447 14.7558 7.82734L17.6162 4.96692C16.0768 3.736 14.1243 3 12 3C9.87498 3 7.92197 3.73648 6.3823 4.96811ZM19.0307 6.38084L16.1705 9.24102C16.6947 10.0318 17 10.9802 17 12C17 13.0198 16.6947 13.9683 16.1705 14.759L19.0307 17.6192C20.2631 16.0793 21 14.1257 21 12C21 9.87431 20.2631 7.92074 19.0307 6.38084ZM17.6162 19.0331L14.7558 16.1727C13.9657 16.6955 13.0184 17 12 17C10.9809 17 10.0331 16.6951 9.24262 16.1716L6.38233 19.0319C7.922 20.2635 9.87499 21 12 21C14.1243 21 16.0767 20.264 17.6162 19.0331ZM4.22617 19.7825C6.21644 21.7706 8.96464 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 15.0354 2.22944 17.7836 4.21751 19.7739C4.21894 19.7753 4.22038 19.7768 4.22183 19.7782C4.22327 19.7796 4.22472 19.7811 4.22617 19.7825ZM12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9Z"
      fill="currentColor"
    />
  </svg>
</template>
